import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { AssessmentDetails } from "Assessments";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default (store, pathName = "schedule") => ({
  path: pathName,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "teacher-newtimetable" */ "./components"),
      import(
        /* webpackChunkName: "teacher-newtimetable" */ "./modules/TimetablePlannerModule"
      ),
      import(
        /* webpackChunkName: "teacher-newtimetable" */ "CoursePlan/modules/CoursePlanModule"
      ),
      import(
        /* webpackChunkName: "teacher-weeklyplanner" */ "LearningCourseWeeklyPlanning/components/WeeklyPlanningView/components/EventComponent/components/CourseFlowModal/modules/CourseFlowModalModule"
      ),
    ]).then(
      ([
        importedModule0,
        importedModule1,
        importedModule2,
        importedModule3,
      ]) => {
        const component = importedModule0.default;

        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "timetablePlanner",
          reducer,
        });

        injectReducer(store, {
          key: "coursePlan",
          reducer: importedModule2.default,
        });

        injectReducer(store, {
          key: "courseFlowModal",
          reducer: importedModule3.default,
        });
        return component;
      }
    )
  ),
  childRoutes: [ClassRoomDetails(store), AssessmentDetails(store)],
});
